import { Page } from "./page";
import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";
import { Utils } from "./utils";

export class PageObjectContainer extends PageObject {
  objects: PageObject[];
  containerOffsetX: number;
  containerOffsetY: number;
  containerWidth: number;
  containerHeight: number;
  scrollHorizontal: boolean;
  scrollVertical: boolean;
  border: string;
  containerHover: boolean;

  constructor(obj: PageObjectContainer = null, page: Page = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Container;

    if (obj == null) {
      this.objects = [];
      this.containerOffsetX = 0;
      this.containerOffsetY = 0;
      this.containerWidth = 0;
      this.containerHeight = 0;
      this.scrollHorizontal = false;
      this.scrollVertical = false;
      this.border = "0px";
      this.containerHover = false;
    } else {
      this.objects = [];
      for (let i = 0; i < obj.objects.length; i++) {
        let newobj = Utils.duplicateObject(obj.objects[i], page, style);
        if (page) {
          let num = 0;
          let found;
          do {
            found = false;
            newobj.name = newobj.name + (num > 0 ? "_" + num : "");
            if (page.checkObjectNameInUse(newobj.name, newobj)) {
              found = true;
            }
            num++;
          } while (found);
        }
        this.objects.push(newobj);
      }
      this.containerOffsetX = 0;
      this.containerOffsetY = 0;
      this.containerWidth = obj.containerWidth;
      this.containerHeight = obj.containerHeight;
      this.scrollHorizontal = obj.scrollHorizontal;
      this.scrollVertical = obj.scrollVertical;
      this.border = obj.border;
      this.containerHover = obj.containerHover;
    }
  }

  getContainerAtPos(x: number, y: number): PageObjectContainer {
    for (let i = 0; i < this.objects.length; i++) {
      if (this.objects[i].type == PAGEOBJECTTYPE.Container) {
        let obj = <PageObjectContainer>this.objects[i];
        if (obj.x <= x && obj.x + obj.width >= x && obj.y <= y && obj.y + obj.height >= y) {
          return obj.getContainerAtPos(x, y);
        }
      }
    }

    return this;
  }

  getObjectContainer(obj: PageObject): PageObjectContainer {
    for (let i = 0; i < this.objects.length; i++) {
      if (this.objects[i] == obj) {
        return this;
      }
      if (this.objects[i].type == PAGEOBJECTTYPE.Container) {
        let container = <PageObjectContainer>this.objects[i];
        let ret = container.getObjectContainer(obj);
        if (ret != null) {
          return ret;
        }
      }
    }

    return null;
  }

  addObject(obj: PageObject): void {
    this.objects.push(obj);
  }

  removeObject(obj: PageObject): void {
    let index = this.objects.indexOf(obj);
    if (index >= 0) {
      this.objects.splice(index, 1);
    }
  }

  sortObjects() {
    this.objects.sort((obj1, obj2) => {
      if (obj1.z > obj2.z) {
        return 1;
      }
      if (obj1.z < obj2.z) {
        return -1;
      }
      return 0;
    });
    for (let i = 0; i < this.objects.length; i++) {
      if (this.objects[i].type == PAGEOBJECTTYPE.Container) {
        (<PageObjectContainer>this.objects[i]).sortObjects();
      }
    }
  }

  clearContainerHover(): void {
    this.containerHover = false;
    for (let i = 0; i < this.objects.length; i++) {
      if (this.objects[i].type == PAGEOBJECTTYPE.Container) {
        let container = <PageObjectContainer>this.objects[i];
        container.clearContainerHover();
      }
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Container Width", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Container Height", OBJECTPROPERTYTYPE.Text));
    let scrollHorizontal = new ObjectProperty("Scroll Horizontal", OBJECTPROPERTYTYPE.List);
    scrollHorizontal.addOption("0", "Disable");
    scrollHorizontal.addOption("1", "Enable");
    list.push(scrollHorizontal);
    let scrollVertical = new ObjectProperty("Scroll Vertical", OBJECTPROPERTYTYPE.List);
    scrollVertical.addOption("0", "Disable");
    scrollVertical.addOption("1", "Enable");
    list.push(scrollVertical);
    let border = new ObjectProperty("Border", OBJECTPROPERTYTYPE.List);
    border.addOption("0px", "None");
    border.addOption("1px solid #000", "Solid");
    border.addOption("1px dashed #000", "Dashed");
    border.addOption("1px dotted #000", "Dotted");
    list.push(border);

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Container Width") {
      return this.containerWidth;
    } else if (name == "Container Height") {
      return this.containerHeight;
    } else if (name == "Scroll Horizontal") {
      return this.scrollHorizontal ? "1" : "0";
    } else if (name == "Scroll Vertical") {
      return this.scrollVertical ? "1" : "0";
    } else if (name == "Border") {
      return this.border;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Container Width") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.containerWidth = newValue;
      }
    } else if (name == "Container Height") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.containerHeight = newValue;
      }
    } else if (name == "Scroll Horizontal") {
      this.scrollHorizontal = value == "1";
    } else if (name == "Scroll Vertical") {
      this.scrollVertical = value == "1";
    } else if (name == "Border") {
      this.border = value;
    }
  }
}
